<template>
  <div class="comhome">
    <div class="main-con">
      <div class="comp">我的工作台</div>
      <div class="list-con">
        <div class="list">
          <div class="item" @click="routo">
            <div class="img backimg">
              <div class="add" style="width: 100px; height: 100px"></div>
            </div>

            <p class="p_one">创建新项目</p>
            <p class="p_last">创建一个空白项目</p>
          </div>
<!--          <div class="item" :key="'list_item_' + index" v-for="(item, index) in comlist">-->
<!--            <div class="img" :style="{-->
<!--              background: `url('${item.coverUrl}') no-repeat center center /100% auto`-->
<!--            }" @click="golink(item.id)"></div>-->
<!--            <div class="info">-->
<!--              <div class="title" @click="golink(item.id)">{{ item.projectName }}</div>-->
<!--              <div class="desc">-->
<!--                <div class="user">{{ item.customerName }}</div>-->
<!--                <div style="display: flex;justify-content: space-between">-->
<!--                  <div class="time">创建于&nbsp;{{item.editTime}}</div>-->
<!--                  <div @click="goDelete(item.id)" v-show="item.canDelete" style="cursor: pointer">-->
<!--                    <i class="el-icon-delete"></i>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <Allcom></Allcom>
<!--        <div v-if="comlist.length == 0" class="loading">暂无任何数据</div>-->
<!--        <div v-else>-->
<!--          <div v-if="nomore" class="loading">已经到达最底部</div>-->
<!--          <div v-else class="loading">加载中...</div>-->
<!--        </div>-->
      </div>
    </div>
<!--    指引视频-->
    <div class="video_but" v-if="viodeShow">
      <img src="../../assets/btn_close@2x.png" class="btn" @click="viodeShow = false"/>
      <img src="../../assets/pic_videoguide@2x.png" style="width: 120px;height: 120px;padding-top: 20px" @click="videoPlay"/>
    </div>
<!--    弹窗视频-->
    <el-dialog
      :visible.sync="dialogviode"
      width="40%"
      title="指引视频"
      :before-close="videoPlayClose">
      <div>
        <div class="videoDom">
          <div class="video">
            <video
              x5-playsinline="true"
              playsinline="true"
              webkit-playsinline="true"
              class="videodom"
              preload="auto"
              controls
              ref="videoNode"
              style="
                width: 100%;
              "
              :src="fileUrl"
            ></video>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { removeToken } from "@/utils/auth";
import {Base64} from "js-base64";
import {setToken} from "../../utils/auth";
import { detailsDelete } from '@/api/projectManage'
import Allcom from "@/views/pc/Allcom";
export default {
  name: 'Comhome',
  components:{
    Allcom
  },
  data() {
    return {
      viodeShow: true,
      comlist: [],
      nomore: false,
      loadinng: false,
      pageNum: 1,
      totalPages: 0,
      centerDialogVisible: false,
      dialogviode: false,
      fileUrl: 'https://helc-cms-file.oss-cn-guangzhou.aliyuncs.com/video/%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E6%8C%87%E5%BC%95%E8%A7%86%E9%A2%91-%E3%80%90%E9%A1%B9%E7%9B%AE%E4%B8%AD%E5%BF%83%E3%80%91%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4',
      // 是否播放视频
      isPlay: false,
      // 定时器
      Loop: null,
    }
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#ffffff;')
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    // 关闭视频
    videoPlayClose() {
      this.$refs.videoNode.pause();
      this.dialogviode = false
      clearTimeout()
      this.fileUrl = ''
    },
    videoPlay() {
      this.dialogviode = true
      this.fileUrl = 'https://helc-cms-file.oss-cn-guangzhou.aliyuncs.com/video/%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E6%8C%87%E5%BC%95%E8%A7%86%E9%A2%91-%E3%80%90%E9%A1%B9%E7%9B%AE%E4%B8%AD%E5%BF%83%E3%80%91%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4'
      setTimeout(()=> {
        this.$refs.videoNode.play()
      }, 1000)
    },
    goDelete(id) {
      this.$confirm('此操作将永久删除该项目信息及项目相关文档，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        detailsDelete(id).then(res => {
          if(res.code === 200){
            this.$message.success('删除成功')
          }
          this.getuser()
        })
        this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    routo() {
      this.$router.push('/manage/newproject')
    },
    // 获取用户的信息
    getuser() {
      this.$store.dispatch('user/getInfo').then((res) => {
        this.userList = res
        console.log(this.userList, '用户信息')
        this.getallcomalist()
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getallcomalist() {
      this.nomore = true
      this.loadinng = true
      this.$request
        .getAllcomList(this.userList.qwUserId,this.pageNum)
        .then((res) => {
          if (res.code == 200) {
            this.comlist = res.data.records
          }
        })
        .finally(() => {
          this.loadinng = false
        })
    },
    // 点击项目跳转
    golink(id) {
      this.$router.push({
        path: '/manage/doclist',
        query: {
          id: id
        }
      })
    },
    getuserpassword() {

    }
  },
  mounted() {
    this.getuser()
  }
}
</script>

<style lang="less" scoped>
.videoDom {
  //width: 50%;
  position: relative;
}
// 视频
.video {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  position: relative;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  // 遮罩层
  .video_overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  // 播放
  .video_play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  video {
    vertical-align: middle;
  }
}
  .btn{
  height: 30px;
  width: 30px;
  position: fixed;
  right: 40px;
  margin-bottom: 50px;

}
.video_but{
  color: white;
  position: fixed;
  right: 50px;
  bottom: 100px;
  cursor: pointer;
}
.comhome {
  &>.main-con {
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;

    &>.comp {
      padding-top: 0.36rem;
      padding-bottom: 0.12rem;
      width: 15.04rem;
      margin: 0 auto;
      min-width: 1000px;
      font-size: 24px;
      font-weight: 550;
      color: rgba(0, 0, 0, 0.85);
    }

    &>.list-con {
      margin-top: 16px;
      box-sizing: border-box;

      &>.list {
        margin: 0 -0.15rem;
        display: flex;
        flex-wrap: wrap;

        &>.item {
          flex: 0 0 3.51rem;
          margin: 0.15rem;
          cursor: pointer;

          &>.img {
            height: 2.31rem;
            border-radius: 0.12rem;
            // background: url('~@/assets/imgs/item-bg.png') no-repeat center
            //   center / 100% auto;
          }

          &>.info {
            &>.title {
              padding-top: 0.12rem;
              color: rgba(0, 0, 0, 0.85);
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              font-weight: bold;
            }

            &>.desc {
              color: rgba(0, 0, 0, 0.45);
              align-items: center;
              height: 0.2rem;
              padding-top: 0.04rem;

              &>.user {
                flex: 0 0 auto;
                color: black;
              }

              &>.time {
                padding-top: 0.04rem;
                flex: 0 0 auto;
              }
            }
          }
        }
      }
    }
  }

  .p_one {
    font-size: 14px;
    margin: 12px 0px 0px 0px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .p_two {
    font-size: 12px;
    margin: 4px 0px;
    padding: 0;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
  }

  .loading {
    text-align: center;
    padding: 40px 0;
    color: #d5d2d2;
  }

  .backimg {
    background: url('~@/assets/imgs/pic_document_add_bg_300@2x.png') no-repeat center center / 100% auto;
  }

  .add {
    background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat center center / 56px auto;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
